export default __webpack_public_path__ + "static/media/jako.066f26df.png";